import "./Spinner.css";
const Spinner = () => <div className="lds-dual-ring"></div>;

export default Spinner
